import {StepRequiresIntervention} from '../../types/Steps'

export const initialRequiresInterventionConfig: Pick<StepRequiresIntervention, 'config' | 'haveWarnings'> = {
  haveWarnings: false,
  config: undefined,
}
